import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ImageMask } from 'elements/visual/ImageMask';
import { EFonts, EGrads } from 'libs/styles/styling';
import styled, { css } from 'styled-components/macro';

interface Props {
    items: {
        iconName?: IconName;
        text: string;
        onClick: () => void;
        highlighted?: boolean;
    }[];
    className?: string;
    highlightedBackground?: string;
    highlightedColor?: string;
}

export const OverflowFilters = (props: Props): JSX.Element => {
    return (
        <S_OverflowFilters className={props.className}>
            {props.items.map((item) => {
                return (
                    <S_OverflowFilter
                        key={item.text}
                        $highlighted={item.highlighted}
                        onClick={item.onClick}
                        $highlightedBackground={props.highlightedBackground}
                        $hasIcon={!!item.iconName}
                    >
                        {item.iconName && (
                            <S_Icon
                                $highlighted={item.highlighted}
                                $highlightedColor={props.highlightedColor ?? '#fff'}
                                icon={['far', item.iconName]}
                            />
                        )}
                        <S_Text
                            $highlighted={item.highlighted}
                            $highlightedColor={props.highlightedColor ?? '#fff'}
                        >
                            {item.text}
                        </S_Text>
                        {item.highlighted && (
                            <ImageMask
                                randomizePosition={true}
                                step={20}
                                image="contour"
                                repeat={true}
                            />
                        )}
                    </S_OverflowFilter>
                );
            })}
        </S_OverflowFilters>
    );
};

const S_OverflowFilters = styled.div`
    display: flex;
    width: fit-content;
    max-width: 100%;
    overflow-y: auto;
    pointer-events: all;
    padding: 0 0px 10px 0;
`;

const S_OverflowFilter = styled.div<{
    $highlighted: boolean;
    $highlightedBackground: string;
    $hasIcon: boolean;
}>`
    display: flex;
    flex-direction: column;
    min-width: 90px;
    height: ${(props) => (props.$hasIcon ? '65px' : '40px')};
    border-radius: 7px;
    box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.15);
    position: relative;
    ${(props) => {
        if (props.$highlighted) {
            return css`
                /* background: linear-gradient(88.56deg, #959595 0%, #484848 100%); ; */
                background: ${() => props.$highlightedBackground || EGrads.ACC2_GRAD}};
            `;
        } else {
            return css`
                background-color: #ffffff;
                &:hover {
                    background-color: #f4f4f4;
                }
            `;
        }
    }}
    justify-content: center;
    cursor: pointer;
    user-select: none;
    &:not(:last-child) {
        margin: 0 10px 0 0;
    }
    @media only screen and (min-width: 1259px) {
        height: ${(props) => (props.$hasIcon ? '90px' : '50px')};
    }
`;

const S_Icon = styled(FontAwesomeIcon)<{ $highlighted: boolean; $highlightedColor: string }>`
    font-size: 20px;
    margin: 0px 0 11px 0;
    font-size: 13px;
    color: ${(props) => (props.$highlighted ? props.$highlightedColor : '#333333')};
    @media only screen and (min-width: 1259px) {
        margin: 5px 0 14px 0;
        font-size: 20px;
    }
`;

const S_Text = styled.div<{ $highlighted: boolean; $highlightedColor: string }>`
    font-size: 13px;
    color: ${(props) => (props.$highlighted ? props.$highlightedColor : '#333333')};
    width: 100%;
    text-align: center;
    font-family: ${EFonts.Regular};
    padding: 0 5px;
    @media only screen and (min-width: 1259px) {
        font-size: 14px;
        font-family: ${EFonts.Medium};
    }
`;
